"use client";
import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./RetailSolutions.css";
import BlueSectionDivider from "./BlueSectionDivider";
import { Link } from "react-router-dom";

const stats = [
  { value: "+90", label: "Specialists" },
  { value: "+20", label: "Industry sectors" },
  { value: "78", label: "Customer NPS Score" },
  { value: "99%", label: "Recommendation Rate" },
  { value: "+300", label: "Projects delivered" }
];

const cards = [
  {
    icon: <img src="/icons/omni.webp" alt="Omnichannel Commerce" />,
    title: "OMNICHANNEL COMMERCE",
    desc: "Create a seamless shopping experience across online, mobile, and physical stores with integrated inventory and fulfillment systems."
  },
  {
    icon: <img src="/icons/crm.webp" alt="CRM" />,
    title: "CUSTOMER RELATIONSHIP MANAGEMENT",
    desc: "Manage customer interactions, analyze behavior, and personalize marketing to boost loyalty and engagement."
  },
  {
    icon: <img src="/icons/case.webp" alt="Inventory & POS" />,
    title: "INVENTORY MANAGEMENT & POS SYSTEM",
    desc: "Track stock levels, streamline checkout, and gain real-time data for efficient sales and inventory control."
  },
  {
    icon: <img src="/icons/supply.webp" alt="Supply Chain" />,
    title: "SUPPLY CHAIN MANAGEMENT & LOGISTICS",
    desc: "Optimize supplier collaboration, route planning, and logistics to ensure availability and reduce operational costs."
  }
];

export default function RetailSolutionsSection() {
  const [active, setActive] = useState("solutions");

  const sectionsToHighlight = [
    "solutions",
    "benefits",
    "tech stack",
    "faq",
    "contact us"
  ];

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const offset = 80;
      const scrollY = window.scrollY + offset;

      for (let i = sectionsToHighlight.length - 1; i >= 0; i--) {
        const section = document.getElementById(sectionsToHighlight[i]);
        if (section && section.offsetTop <= scrollY) {
          setActive(sectionsToHighlight[i]);
          break;
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClick = (id) => {
    setActive(id);
    const section = document.getElementById(id);
    section?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <>
      {/* Sticky Navbar */}
      <div className="retail-navbar">
        <div className="container">
          <ul>
            {sectionsToHighlight.map((item) => (
              <li key={item}>
                <a
                  onClick={() => handleClick(item)}
                  className={active === item ? "active" : ""}
                >
                  {item.toUpperCase()}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Section Content */}
      <section className="retail-section" id="solutions">
        <div className="container">
          <div className="retail-stats-row" data-aos="fade-up">
            {stats.map((stat, i) => (
              <div className="retail-stat" key={i}>
                <div className="retail-stat-value">{stat.value}</div>
                <div className="retail-stat-label">{stat.label}</div>
              </div>
            ))}
            <BlueSectionDivider />
          </div>

          <div className="retail-title-group" data-aos="fade-up">
            <div className="retail-title">DIGITAL SOLUTIONS</div>
            <div className="retail-title-blue">
              FOR THE DIFFERENT RETAIL AREAS
            </div>
          </div>

          <div className="retail-cards-grid">
            {cards.map((card, i) => (
              <div
                className="retail-card"
                key={i}
                data-aos="fade-up"
                data-aos-delay={100 + i * 100}
              >
                <div className="retail-card-icon">{card.icon}</div>
                <div className="retail-card-title">{card.title}</div>
                <div className="retail-card-desc">{card.desc}</div>
              </div>
            ))}
          </div>

          <div
            className="retail-cta-row"
            data-aos="fade-up"
            data-aos-delay="600"
          >
            <Link to="/contact" className="retail-cta-btn">
              GET STARTED WITH YOUR RETAIL DIGITAL PRODUCT
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
